





















































import { defineComponent } from "@vue/composition-api";
import Header from "@/components/Header.vue";

export default defineComponent({
  name: "Welcome",
  components: {
    Header,
  },
  setup(_, { root }) {
    const login = () => {
      let url =
        window.location.origin +
        "/google_auth/redirect?client_type=pwa&base_url=" +
        window.location.origin;
      if (root.$route.query.agency_id) {
        url += "&agency_id=" + root.$route.query.agency_id;
      }
      location.href = url;
    };
    const currentSlide = (index) => {
      return `slide${index}`;
    };

    return {
      login,
      currentSlide,
    };
  },
});
